import { trackDownloadButtonClick } from '~pages/pages-behind-login/financials/vessel-financials/components/download-tables-button'

export function downloadFile({ url, title }: { url: string; title: string }) {
  // It is possible that components no longer need this function,
  // since Azure blob storage takes care of the download/preview functionality via Content-Disposition header.
  trackDownloadButtonClick(title)

  const a = document.createElement('a')
  a.href = url
  a.target = '_blank'
  a.download = title
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
}
